import { render } from "./OpcaoVisualizacao.vue?vue&type=template&id=26df90d4&scoped=true&ts=true"
import script from "./OpcaoVisualizacao.vue?vue&type=script&lang=ts"
export * from "./OpcaoVisualizacao.vue?vue&type=script&lang=ts"

import "./OpcaoVisualizacao.vue?vue&type=style&index=0&id=26df90d4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26df90d4"]])

export default __exports__